import { monthlySWPForSIP } from "../../engine/calculations";

const config = {
  key: "swp-monthly-for-sip",
  title: "Monthly SWP For SIP",
  category: "Retirement & Income",
  description: "Build a corpus via SIP, then see the level monthly income it can pay out afterwards.",
  fields: [
    { key: "monthly", label: "Monthly SIP amount", type: "currency", default: 15_000, min: 500, max: 10_00_000 },
    { key: "sipYears", label: "Years you'll invest", type: "number", default: 20, min: 1, max: 40 },
    { key: "buildReturn", label: "Return while building the corpus", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "withdrawYears", label: "Years the income should last", type: "number", default: 20, min: 1, max: 50 },
    { key: "withdrawReturn", label: "Return during withdrawal", type: "percent", default: 7, min: 1, max: 20, assumptionKey: "debtReturn" },
  ],
  compute(values) {
    const monthly = Number(values.monthly) || 0;
    const sipYears = Number(values.sipYears) || 0;
    const buildReturn = (Number(values.buildReturn) || 0) / 100;
    const withdrawYears = Number(values.withdrawYears) || 0;
    const withdrawReturn = (Number(values.withdrawReturn) || 0) / 100;

    const result = monthlySWPForSIP(monthly, buildReturn, sipYears, withdrawReturn, withdrawYears);

    return {
      headline: { label: "Sustainable monthly income", value: result.monthlyWithdrawal },
      extraHeadlines: [{ label: "Corpus built", value: result.corpus }],
      breakdown: [{ label: "Total invested", value: monthly * sipYears * 12 }],
    };
  },
};

export default config;
